module.exports = __webpack_public_path__ + "img/gift-04-c2.a2ab4391.png";